"use strict";

angular.module("core")
.factory("PaymentMethodsCreditCardService", function($resource, $http, appConfig) {
    return {
        getClientAccounts: function(vendorId) {
            if (vendorId) {
                return $http.get(appConfig.API_SERVER + "/payment-methods/moneris/" + appConfig.APP + "/client-accounts/" + vendorId + "/");
            }
            return $http.get(appConfig.API_SERVER + "/payment-methods/moneris/" + appConfig.APP + "/client-accounts/");
        },

        updateClientAccount: function(vendorId, creditCardAccountId) {
            var data = {default_credit_card_account: creditCardAccountId};
            return $http.put(appConfig.API_SERVER + "/payment-methods/moneris/" + appConfig.APP + "/client-accounts/" + vendorId + "/", data);
        },

        preloadCreditCard: function(vendorId) {
            return $http.post(appConfig.API_SERVER + "/payment-methods/moneris/" + appConfig.APP + "/credit-card-accounts/" + vendorId + "/", {
                "request_type": "preload"
            }, {
                ignoreLoadingBar: true
            });
        },

        receiptCreditCard: function(vendorId, ticket) {
            return $http.post(appConfig.API_SERVER + "/payment-methods/moneris/" + appConfig.APP + "/credit-card-accounts/" + vendorId + "/", {
                "request_type": "receipt",
                "ticket": ticket
            }, {
                ignoreLoadingBar: true
            });
        },

        getCreditCardAccount: function(vendorId, creditCardAccountId) {
            return $http.get(appConfig.API_SERVER + "/payment-methods/moneris/" + appConfig.APP + "/credit-card-accounts/" + vendorId + "/" + creditCardAccountId + "/");
        },

        deleteCreditCardAccount: function(vendorId, creditCardAccountId) {
            return $http.delete(appConfig.API_SERVER + "/payment-methods/moneris/" + appConfig.APP + "/credit-card-accounts/" + vendorId + "/" + creditCardAccountId + "/");
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/payment-methods/payment-methods-credit-card.service.js
// module id = 443
// module chunks = 0